var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.8l-.1-.4c-.1-.1-.1-.2-.2-.3L10.6.3c-.4-.4-1.1-.4-1.5 0-.2.2-.3.5-.3.8s.1.6.3.8l3.1 3H1.1c-.6-.1-1.1.4-1.1 1S.5 7 1.1 7h11.1l-3.1 3c-.2.2-.3.5-.3.8s.1.6.3.8.5.4.8.4.5-.1.8-.3l5-4.8c.2-.2.3-.4.3-.7v-.4z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.2504de904721d0444a0ae164bd9ed03a.svg";
export { ForwardRef as ReactComponent };